import { createApp } from 'vue';
import axios from 'axios'

import communityList from './community-list.vue'

export const app = createApp({
	data() {
		return {
			communities: [],
			categories: [],
			types: [],
			translations: [],
			loading: true,
			selectedCategory: 'none'
		};
	},
	mounted() {
		const url = document.body.getAttribute('data-base-url');

		axios.get(url + 'community/community.json?limit=9')
		.then(response => {
			this.communities = response.data.communities;
			this.categories = response.data.categories;
			this.types = response.data.newsTypes;
			this.translations = response.data.translations;
			this.loading = false;
		})
	}
})
app.component("community-list", communityList);
app.mount('#community-app');
